/* global L, turf */



var Map = {

  secret: null,

  mapElementId: null,

  mapId: null,

  map: null,

  themeUrl: null,

  currentUserLocation: null,

  defaultUserLocation: null,

  defaultReactor: null,

  reactors: null,

  reactorsOnMap: [],

  userMarker: [],

  USBounds: new L.latLngBounds([
    [22, -130],
    [54, -60]
  ]),

  positionOptions: [
    {
      min: 0,
      max: 768,
      pan: [300, 80],
      zoom: 4,
      alignment: 'east'
    },
    {
      min: 768,
      max: 992,
      pan: [300, 80],
      zoom: 9,
      alignment: 'east'
    },
    {
      min: 992,
      max: 99999,
      pan: [359, 80],
      zoom: 10,
      alignment: 'east'
    }
  ],

  /**
   * Initialize Map Properties
   * @param props
   */
  init: function(props) {
    this.secret = props.secret;
    this.mapElementId = props.mapElementId;
    this.mapId = props.mapId;
    this.themeUrl = props.themeUrl;
    this.reactors = props.reactors;
  },

  /**
   * Create Map centered on starting location
   * @param {Object} startingLocation
   * @param {Object} options
   */
  createHeaderMap: function(startingLocation, options) {

    if (!options) {
      options = {};
    }

    if (document.getElementById(this.mapElementId)) {
      L.mapbox.accessToken = this.secret;

      var self = this;

      this.defaultUserLocation = startingLocation;

      this.map = L.mapbox.map(this.mapElementId, this.mapId, options);

      this.map.dragging.disable();
      this.map.touchZoom.disable();
      this.map.doubleClickZoom.disable();
      this.map.scrollWheelZoom.disable();

      this.defaultReactor = this.addDefaultReactor();
      this.updatePan(this.getReactorCoordinates(this.defaultReactor));

      this.map.addEventListener('resize', function() {
        var center = self.getReactorCoordinates(self.defaultReactor);

        if (self.currentUserLocation && self.reactors.features.length) {
          var pan = self.getPanByScreenSize();
          switch (pan.alignment) {
            case 'east':
              center = self.getEasternMostReactorCoordinates();
              break;
            default:
              center = self.getEasternMostReactorCoordinates();
          }
        }
        self.updatePan(center);
      });
    }
  },

  /**
   * Add Default Reactor
   * @returns {Object} Nearest Reactor Object
   */
  addDefaultReactor: function() {
    var defaultReactor = this.findNearestReactor(this.defaultUserLocation);

    this.addSingleReactor(defaultReactor, true, true);

    return defaultReactor;
  },

  /**
   * Get Reactor Center
   * @returns {L.latLng}
   */
  getReactorsCenter: function() {
    var bounds = [];

    var self = this;

    this.reactors.features.forEach(function(reactor) {
      bounds.push(self.getReactorCoordinates(reactor));
    });

    return L.latLngBounds(bounds).getCenter();
  },

  /**
   * Returns eastern most reactor coordinates.
   * @returns {L.latLng}
   */
  getEasternMostReactorCoordinates: function() {
    var bounds = [];

    var self = this;

    var easternMostReactorCoords = null;

    this.reactors.features.forEach(function(reactor) {

      if(!easternMostReactorCoords || self.getReactorCoordinates(reactor).lng > easternMostReactorCoords.lng) {
        easternMostReactorCoords = self.getReactorCoordinates(reactor);
      }
    });


    return easternMostReactorCoords;
  },

  updatePan: function(centerCoordinates) {
    var pan = this.getPanByScreenSize();

    var centerPointInPixels = this.map.options.crs.latLngToPoint(centerCoordinates, pan.zoom);

    centerPointInPixels.x = centerPointInPixels.x + pan.pan[0];
    centerPointInPixels.y = centerPointInPixels.y + pan.pan[1];

    var adjustedCenter = this.map.options.crs.pointToLatLng(centerPointInPixels, pan.zoom);

    this.map.setView(adjustedCenter, pan.zoom);
  },

  /**
   * Returns an array of reactors filtered by distance
   * @param distance
   * @param includeUntargeted
   * @param {int} maximumReactors
   *
   * @returns {Array.<T>}
   */
  filterNearbyReactors: function(distance, includeUntargeted, maximumReactors) {

    var distanceInMeters = distance * 1609.34;

    var self = this;

    var userLocation = L.latLng(self.currentUserLocation.lat, self.currentUserLocation.lng);

    var filteredReactors = this.reactors.features.filter(function(element) {
      var include = userLocation.distanceTo(self.getReactorCoordinates(element)) < distanceInMeters;
      if (includeUntargeted) {
        return include;
      }
      return include && element.properties.targeted;
    });

    //Sort Reactors from closest to farthest and return.
    filteredReactors.sort(function(a, b) {
      return userLocation.distanceTo(self.getReactorCoordinates(a)) - userLocation.distanceTo(self.getReactorCoordinates(b));
    });

    if(!isNaN(parseInt(maximumReactors, 10))) {
      filteredReactors = filteredReactors.slice(0, maximumReactors);
    }

    return filteredReactors;

  },

  /**
   * Get updated pan attributes depending upon screen size.
   * @returns {*}
   */
  getPanByScreenSize: function() {

    var panSize;

    var width = window.outerWidth;

    for (var i = 0; i < this.positionOptions.length; i++) {

      if (width < this.positionOptions[i].max && width >= this.positionOptions[i].min) {
        panSize = this.positionOptions[i];
        break;
      }
    }

    return panSize;
  },

  /**
   * Returns geoJSon Object of reactors
   * @returns {null|Object}
   */
  getGeoJsonData: function() {
    return this.reactors;
  },

  /**
   * Returns an Icon Object
   * @returns {*}
   */
  getReactorIcon: function() {
    return L.icon({
      iconUrl: this.themeUrl + '/dist/images/pinpoint-large.png',
      iconSize: [85, 70],
      iconAnchor: [61, 62],
      className: "reactor"
    });
  },

  /**
   * Add All Reactors to the map
   *
   * @param {Boolean} addLabels Add Labels to reactors
   * @param {Boolean} addPopups Add Popups to reactors on hover
   */
  addReactors: function(addLabels, addPopups) {
    var self = this;

    var layer = L.mapbox.featureLayer().addTo(this.map);

    layer.on('layeradd', function(e) {
      self.addIconAndCircle(e.layer.feature, e.layer, addLabels, false);
    });

    if(addPopups) {

      var popup = L.popup({
        closeButton: false,
        offset: L.point(0, -55),
        className: 'reactor-info'
      });

      layer.on('mouseover', function(e) {
        popup.setLatLng(e.latlng);
        popup.setContent(e.layer.feature.properties.name);
        popup.openOn(self.map);
      });

      layer.on('mouseout', function() {
        self.map.closePopup();
      });
    }

    layer.setGeoJSON(this.getGeoJsonData());
  },

  /**
   * Add a single reactor to the map
   * @param {Object} reactor geoJSon Feature
   * @param {Boolean} addLabel Add Label to Reactor
   * @param {Boolean} useDefaultLabel Use Default Label
   */
  addSingleReactor: function(reactor, addLabel, useDefaultLabel) {
    var self = this;

    if (!this.isReactorOnMap(reactor)) {
      var layer = L.mapbox.featureLayer().addTo(this.map);

      layer.on('layeradd', function(e) {
        self.addIconAndCircle(reactor, e.layer, addLabel, useDefaultLabel);
      });
      layer.setGeoJSON([reactor]);

      this.reactorsOnMap.push(reactor);
    }
  },

  /**
   * Add Icon, circle and text description of nuclear plant
   * @param feature
   * @param layer
   * @param {boolean} addLabel
   * @param {boolean} useDefaultLabel Indicates that a default label should be used
   */
  addIconAndCircle: function(feature, layer, addLabel, useDefaultLabel) {
    var iconLayer = layer.setIcon(this.getReactorIcon());

    this.addReactorCircle(this.getReactorCoordinates(feature));

    if (addLabel) {
      var label = 'Nuclear Power Plant';
      if (!useDefaultLabel) {
        label = feature.properties.name;
      }

      var textIcon = this.getTextIcon(label);

      L.marker(this.getReactorCoordinates(feature), {icon: textIcon}).addTo(this.map);
    }
  },

  getTextIcon: function(label) {
    return L.divIcon({
      className: 'reactor-location-label',
      html: '<p>' + label + '</p>',
      iconAnchor: [-27, 60],
      iconSize: null
    });
  },

  /**
   * Returns true if reactor has already been placed on the map
   * @param reactor
   * @returns {boolean}
   */
  isReactorOnMap: function(reactor) {
    return this.reactorsOnMap.indexOf(reactor) >= 0;
  },

  /**
   * Add 20 mile circle around reactor
   * @param {LatLng} point
   */
  addReactorCircle: function(point) {
    L.circle(point, 32186.9,
      {
        'color': '#d98e5c',
        'opacity': 1,
        'fillColor': '#f6f58b',
        'fillOpacity': 0.6,
        'className': 'reactor-circle'
      }).addTo(this.map);
  },

  /**
   * Find nearest reactor to location
   * @param {latLng} location
   * @returns {*}
   */
  findNearestReactor: function(location) {
    /**
     * @type {turf-point}
     */
    var turfPoint = turf.point([location.lng, location.lat]);

    return turf.nearest(turfPoint, this.getGeoJsonData());
  },

  /**
   * Convenience method to extract latitude and longitude from reactor.
   * @param reactor
   *
   * @return L.latLng
   */
  getReactorCoordinates: function(reactor) {
    return L.latLng(reactor.geometry.coordinates[1], reactor.geometry.coordinates[0]);
  },

  /**
   *
   * @param {L.Point} center
   * @param {L.Point} point
   * @returns {L.Bounds}
   */
  getBoundsWithCenterAndPoint: function(center, point) {

    var fauxLat = center.lat - (point.lat - center.lat);

    var fauxLng = center.lng - (point.lng - center.lng);

    var fauxPoint = L.latLng(fauxLat, fauxLng);

    return L.latLngBounds([point, fauxPoint]);
  },

  drawVectorToReactor: function(userLoc, reactorLoc) {
    var polyline = L.polyline([userLoc, reactorLoc], {
      color: '#332e77'
    });

    polyline.addTo(this.map);
  },

  clearPolylineLayers: function() {

    var self = this;

    this.map.eachLayer(function(l) {
      if (l instanceof L.Polyline) {
        self.map.removeLayer(l);
      }
    });
  },

  updateUserMarker: function(location) {
    if (this.userMarker) {
      this.map.removeLayer(this.userMarker);
    }

    if(location !== null ) {
      var userIcon = L.icon({
        iconUrl: this.themeUrl + '/dist/images/user-point.png',
        iconSize: [20, 20],
        iconAnchor: [10, 10],
        className: "user-icon"
      });

      this.userMarker = L.marker(location, {
        icon: userIcon
      });

      this.userMarker.addTo(this.map);
    }
  },

  /**
   * Get Reactor titles
   * @returns {Array}
   */
  getReactorTitles: function() {

    var titles = [];

    this.reactors.features.forEach(function(reactor) {
      titles.push(reactor.properties.name);
    });

    return titles;
  },

  /**
   * Get Reactor By Id
   * @param id
   * @returns {*}
   */
  getReactorById: function(id) {
    var reactor = null;

    for (var i = 0; i < this.reactors.features.length && !reactor; i++) {
      if (parseInt(this.reactors.features[i].properties.id, 10) === parseInt(id, 10)) {
        reactor = this.reactors.features[i];
      }
    }
    return reactor;
  },

  /**
   * Converts Distance to Miles
   * @param distance
   * @returns {number}
   */
  convertDistanceToMiles: function(distance) {
    return distance / 1609.34;
  },
};
